import React from 'react';
import {Typography} from '../typography';
import {Box} from '../box';
import {FrameworkImage} from '../image-renderer';
import {getRandomImage} from './utils';

export interface NFTBackgroundItemProps {
  index: number;
}

export const NFTBackgroundItem: React.FC<NFTBackgroundItemProps> = ({
  index,
}: NFTBackgroundItemProps) => {
  return (
    <Box width="100%" flexDirection="column" overflow="hidden" bg="surfaceDark">
      <Box>
        <Box
          style={{
            paddingTop: '100%',
            opacity: 0.84,
          }}
          css={{
            filter: 'blur(48px)',
          }}
        >
          <FrameworkImage
            src={getRandomImage(index)}
            alt=""
            layout="fill"
            objectFit="cover"
          />
        </Box>
      </Box>
      <Box
        p="one"
        borderTopStyle="solid"
        borderTopWidth="one"
        borderTopColor="outlines"
      >
        <Typography color="textLow" textStyle="s">
          {' '}
        </Typography>
      </Box>
      <Box marginX="one">
        <Typography color="textLow" textStyle="s">
          {' '}
        </Typography>
      </Box>
      <Box
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        m="one"
      >
        <Box flexDirection="row" alignItems="center">
          {' '}
        </Box>{' '}
      </Box>
    </Box>
  );
};
